module.exports = __webpack_public_path__ + "static/media/Sepa-home.b14e5802.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/Sepa-home.PNG
// module id = 92
// module chunks = 0